module.exports = __webpack_public_path__ + "media/triviasound.e3b9ee9d.mp3";